// extracted by mini-css-extract-plugin
module.exports = {"panel":"contact-module--panel--1pVHK","contactTable":"contact-module--contactTable--1cgIn"};